// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a91dc771","455":"5ca5c2e5"}[chunkId] + ".chunk.js";
};